/**
 * Liste des juridictions pénales belges (référence pour autocomplete).
 *
 * Source : organisation judiciaire BE 2026. Couvre les juridictions où
 * un dossier pénal peut être pendant — pas exhaustif sur les sous-divisions
 * locales (Maxim peut compléter manuellement le suffixe « ... — division
 * X » si besoin).
 *
 * Ordre : du plus haut (Cassation) au plus bas (police), groupé par
 * fonction. Utilisable directement comme `<datalist>` pour autocomplete
 * natif HTML5.
 */

export const JURIDICTIONS_BE: readonly string[] = [
  // === Cour de cassation ===
  'Cour de cassation',

  // === Cours d\'appel (5 ressorts) ===
  "Cour d'appel de Bruxelles",
  "Cour d'appel de Liège",
  "Cour d'appel de Mons",
  "Cour d'appel d'Anvers",
  "Cour d'appel de Gand",

  // === Chambres des mises en accusation (CMA) — une par cour d'appel ===
  'Chambre des mises en accusation — Bruxelles',
  'Chambre des mises en accusation — Liège',
  'Chambre des mises en accusation — Mons',
  'Chambre des mises en accusation — Anvers',
  'Chambre des mises en accusation — Gand',

  // === Cours d\'assises (provinces + Bruxelles) ===
  "Cour d'assises de Bruxelles",
  "Cour d'assises du Brabant wallon",
  "Cour d'assises de Liège",
  "Cour d'assises du Hainaut (Mons)",
  "Cour d'assises du Hainaut (Charleroi)",
  "Cour d'assises de Namur",
  "Cour d'assises du Luxembourg",
  "Cour d'assises d'Anvers",
  "Cour d'assises de Flandre occidentale",
  "Cour d'assises de Flandre orientale",
  "Cour d'assises du Limbourg",
  "Cour d'assises du Brabant flamand",

  // === Tribunaux correctionnels (fond) ===
  'Tribunal correctionnel de Bruxelles francophone',
  'Tribunal correctionnel de Bruxelles néerlandophone',
  'Tribunal correctionnel du Brabant wallon (Nivelles)',
  'Tribunal correctionnel de Liège — division Liège',
  'Tribunal correctionnel de Liège — division Huy',
  'Tribunal correctionnel de Liège — division Verviers',
  'Tribunal correctionnel de Namur — division Namur',
  'Tribunal correctionnel de Namur — division Dinant',
  'Tribunal correctionnel du Luxembourg — division Arlon',
  'Tribunal correctionnel du Luxembourg — division Marche-en-Famenne',
  'Tribunal correctionnel du Luxembourg — division Neufchâteau',
  'Tribunal correctionnel du Hainaut — division Mons',
  'Tribunal correctionnel du Hainaut — division Charleroi',
  'Tribunal correctionnel du Hainaut — division Tournai',
  "Tribunal correctionnel d'Eupen",
  "Tribunal correctionnel d'Anvers — division Anvers",
  "Tribunal correctionnel d'Anvers — division Malines",
  "Tribunal correctionnel d'Anvers — division Turnhout",
  'Tribunal correctionnel de Flandre orientale — division Gand',
  'Tribunal correctionnel de Flandre orientale — division Termonde',
  'Tribunal correctionnel de Flandre orientale — division Audenarde',
  'Tribunal correctionnel de Flandre occidentale — division Bruges',
  'Tribunal correctionnel de Flandre occidentale — division Courtrai',
  'Tribunal correctionnel de Flandre occidentale — division Ypres',
  'Tribunal correctionnel de Flandre occidentale — division Furnes',
  'Tribunal correctionnel du Limbourg — division Hasselt',
  'Tribunal correctionnel du Limbourg — division Tongres',
  'Tribunal correctionnel du Brabant flamand (Louvain)',

  // === Chambres du conseil (règlement de la procédure) ===
  // Le règlement se tient dans le tribunal de première instance — on
  // reprend la même grille géographique avec le label CC.
  'Chambre du conseil de Bruxelles francophone',
  'Chambre du conseil de Bruxelles néerlandophone',
  'Chambre du conseil du Brabant wallon (Nivelles)',
  'Chambre du conseil de Liège — division Liège',
  'Chambre du conseil de Liège — division Huy',
  'Chambre du conseil de Liège — division Verviers',
  'Chambre du conseil de Namur — division Namur',
  'Chambre du conseil de Namur — division Dinant',
  'Chambre du conseil du Luxembourg — division Arlon',
  'Chambre du conseil du Hainaut — division Mons',
  'Chambre du conseil du Hainaut — division Charleroi',
  'Chambre du conseil du Hainaut — division Tournai',
  "Chambre du conseil d'Eupen",
  "Chambre du conseil d'Anvers",
  'Chambre du conseil de Flandre orientale',
  'Chambre du conseil de Flandre occidentale',
  'Chambre du conseil du Limbourg',
  'Chambre du conseil du Brabant flamand (Louvain)',

  // === Tribunaux de police (roulage + petite délinquance) ===
  // Un par arrondissement judiciaire.
  'Tribunal de police de Bruxelles francophone',
  'Tribunal de police de Bruxelles néerlandophone',
  'Tribunal de police du Brabant wallon',
  'Tribunal de police de Liège',
  'Tribunal de police de Namur',
  'Tribunal de police du Luxembourg',
  'Tribunal de police du Hainaut',
  "Tribunal de police d'Eupen",
  "Tribunal de police d'Anvers",
  'Tribunal de police de Flandre orientale',
  'Tribunal de police de Flandre occidentale',
  'Tribunal de police du Limbourg',
  'Tribunal de police du Brabant flamand',

  // === Tribunaux de l\'application des peines (TAP) ===
  // 5 ressorts (un par cour d'appel).
  "Tribunal de l'application des peines — Bruxelles",
  "Tribunal de l'application des peines — Liège",
  "Tribunal de l'application des peines — Mons",
  "Tribunal de l'application des peines — Anvers",
  "Tribunal de l'application des peines — Gand",
] as const;
